// @flow
import { APICore } from './apiCore';

const api = new APICore();

// account
// function ApiGetAllKategoriFasilitas(params: any): any {
//     const baseUrl = '/api/admin/kategorimenu';
//     return api.get(`${baseUrl}`, params);
// }
function ApiGetAllTax(params: any): any {
    const baseUrl = '/api/admin/taxservice';
    return api.get(`${baseUrl}`, params);
}
// function ApiPostCategoryRoom(params: any): any {
//     const baseUrl = '/api/admin/kategoriroom';
//     return api.create(`${baseUrl}`, params);
// }
function ApiPostTax(params: any): any {
    const baseUrl = '/api/admin/taxservice';
    // console.log('🚀 ~ ApiPostFasilitas ~ params:', params);
    return api.create(`${baseUrl}`, params);
}
// function ApiEditKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.update(`${baseUrl}`, params);
// }
function ApiEditTax(params: any, id: any): any {
    // console.log('🚀 ~ ApiEditTax ~ params:', params);
    const baseUrl = '/api/admin/taxservice/' + id;
    // console.log('🚀 ~ ApiEditTax ~ id:', id);
    return api.update(`${baseUrl}`, params);
}
// function ApiDeleteKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.delete(`${baseUrl}`, params);
// }

export {
    // ApiGetAllKategoriMenu,
    ApiGetAllTax,
    // ApiPostCategoryRoom,
    ApiPostTax,
    // ApiEditKategoriRoom,
    ApiEditTax,
    // ApiDeleteKategoriRoom,
};
